import {Component,createSignal,For,onMount,Show} from 'solid-js';
import {cleanImagePath, getOrSetAsync} from './API';

type ArtistImage = {
    id: number;
    name: string;
    viewerUrl: string;
    imageUrl: string;
    credit: string;
    description: string;
};

export const ArtistImagesTab : Component<any> = (props) => {
    const [images, setImages] = createSignal<any[]>([]);
    const getData = async () => {
        const json = await getOrSetAsync("artist-images/" + props.artistId, async () => {
            const response = await fetch(props.baseUrl + "/Artist/SolidArtistImagesJson?id=" + props.artistId);
            return await response.json();
        });
        return json;
    };
    onMount(async () => {
        const json = await getData();
        const images = json.Data.map((item: any) => {
            return {
                id: item.Id,
                name: item.Name,
                viewerUrl: "/Common/Image?imageId=" + item.Id,
                imageUrl: item.URL,
                description: item.Description
            } as ArtistImage;
        });
        setImages(images);
    });
return (
<section class="salon-results">
    <div style="background-color: #333; position: relative; text-align: center;">
        <div class="finalist-grid">
            <div class="grid-sizer"></div>
            <For each={images()}>{(image: ArtistImage) =>
                <div style="display: inline-block;">
                    <div class="grid-item" style="display: inline-block; text-align: left; vertical-align: top; width: 325px;">
                        <div style="position: relative;">
                            <div>
                                <a href={ image.viewerUrl }>
                                    <img src={ cleanImagePath(image.imageUrl) + "?w=325&mode=crop" } style="width: 325px; height: auto;" />
                                </a>
                            </div>
                        </div>
                        <div class="didactic">
                            <Show when={!!image.name}>
                                <h4><a href={image.viewerUrl}>{image.name}</a></h4>
                            </Show>
                            <Show when={!!image.description}>
                                <div innerHTML={image.description}></div>
                            </Show>
                            <Show when={!!image.credit && image.credit != "None"}>
                                <p style="font-size: 1em;">
                                    Credit: {image.credit}
                                </p>
                            </Show>                            
                        </div>
                    </div>
                </div>
            }</For>
        </div>
    </div>
</section>);
}